import { 
  withStyles, 
  Container, 
  TextField, 
  Box, 
  TextareaAutosize,
  Button,
  Typography,
} from "@material-ui/core";

import { 
  Send, 
  PermIdentity,
  PhoneInTalk,
  BorderColor 
} from '@material-ui/icons';

import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import* as generalAction from "../../actions/general";
import styles from "./styles";
import MapItem from './../../components/MapItem';
import Breadcrumbs from "../../components/Breadcrumbs";
import Seo from "../../components/Seo";

function ContactPage(props) {
  const { classes, generalActionContent, generalContent } = props;
  const { fetchGeneralContent, saveContact } = generalActionContent;
  const [state, setState] = useState({})

  useEffect(() => {
    fetchGeneralContent();
  }, [fetchGeneralContent]);

  const mapParams = () => {
    let params = [{ name: "Liên hệ", cate: "contact", to: "/lien-he" }];

    // if (item) {
    //   params.push({
    //     name: item.name,
    //     cate: "news-child",
    //     to: item.alias
    //   });
    // }

    return params;
  };
  
  const onSubmit = (e) => {
    e.preventDefault()
    saveContact(state)
  }

  const onChange = e => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    state[name] = value
    setState({...state})
  }

  return (
    <div>
      <Seo seoContent={generalContent}/>
      <Container maxWidth="xl">
      <Breadcrumbs params={mapParams()} />
        <div className={classes.root}>
          <div className={classes.contactLeft}>
            <Typography component="div" variant="body1">
              <div className="information">
                <p>{generalContent.name}</p>
                <span>
                  <strong>Email: </strong>
                  <a title="email" href={`mailto:${generalContent !== undefined ? generalContent.email : ""}`}>{generalContent !== undefined ? generalContent.email : ""}</a>
                </span>
                <br></br>
                <span>
                  <strong>Phone: </strong>
                  <a title="hotline" href={`tel:${ generalContent.phone }`}>{generalContent.phone }</a>
                </span>
                <br></br>
                <span>{generalContent.address}</span>
              </div>
              <form onSubmit={onSubmit}>
                <div className="informationContact">
                  <p>Thông tin liên hệ</p>
                  <div>
                    <Box color="secondary.main"> (*) </Box>
                    <span> : Thông tin bắt buộc</span>
                  </div>
                  <div>
                    <div>
                      <PermIdentity> </PermIdentity>
                    </div>
                    <TextField  onChange={onChange} name="name" fullWidth id="name" label="Full name" />
                    <Box color="secondary.main">(*)</Box>
                  </div>
                  <div>
                    <div><PhoneInTalk></PhoneInTalk></div>
                    <TextField onChange={onChange} name="phone" fullWidth id="phone" label="Phone"
                    />
                    <Box color="secondary.main">(*)</Box>
                  </div>
                  <div>
                    <div><BorderColor></BorderColor></div>
                    <TextareaAutosize
                      onChange={onChange}
                      name="content"
                      rows={2}
                      aria-label="maximum height"
                      placeholder="Please enter content..."
                    />
                    <Box color="secondary.main">(*)</Box>
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      className={classes.button}
                      startIcon={<Send>send</Send>}
                    >
                      Send
                    </Button>
                  </div>
                </div>
              </form>
            </Typography>
          </div>
          <div className={classes.contactRight}>
            <form>
              <MapItem></MapItem>
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    generalContent: state.general.generalContent,
  }
}

const mapDisPatchToProps = dispatch => {
  return {
    generalActionContent: bindActionCreators(generalAction, dispatch)
  }
}

const withConnect = connect(mapStateToProps, mapDisPatchToProps);

export default compose(withStyles(styles), withConnect)(ContactPage);